import styles from "./RelevanceSlider.module.scss";
import { Tooltip } from "antd";
import classNames from "classnames";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { SEMANTIC_RELEVANCE_THRESHOLD } from "../../../../../../helpers/constants/miscellaneous";
import { useEffect, useState } from "react";
import VLSlider from "views/uikit/VLSlider";

export const RelevanceSlider = ({ className }: { className?: string }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const valueFromUrl =
    Number(searchParams.get(SEMANTIC_RELEVANCE_THRESHOLD)) * 100 || 0;
  const [value, setValue] = useState(valueFromUrl);
  useEffect(() => {
    if (valueFromUrl >= 0) {
      setValue(valueFromUrl);
    }
  }, [valueFromUrl]);
  const formatter = (value = 0) => `≥ ${Math.round(value)}%`;
  const setValueInQuery = (currentValue: number) => {
    searchParams.set(SEMANTIC_RELEVANCE_THRESHOLD, String(currentValue / 100));
    setSearchParams(searchParams);
  };
  return (
    <div className={classNames(styles.container, className)}>
      <div>Relevance</div>
      <Tooltip title="Results are scored from 0–100 for vector-based searches. Higher values return fewer, more accurate matches.">
        <InfoCircleOutlined className={styles.icon} />
      </Tooltip>
      <VLSlider
        className={styles.slider}
        min={0}
        max={100}
        value={value}
        onChange={(v) => setValue(v)}
        step={1}
        tooltip={{
          formatter,
        }}
        onChangeComplete={setValueInQuery}
      />
      <div>{formatter(value)}</div>
    </div>
  );
};
